module.exports = __webpack_public_path__ + "static/media/automotive_software_development.1c7711a4.svg";